import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "vue-select/dist/vue-select.css";
import moment from "moment-timezone";
import VueSweetalert2 from "vue-sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";
//createApp(App).use(store).use(router).mount("#app");

const app = createApp(App);
app.config.globalProperties.$filters = {
  formatDate: function (date) {
    return moment(date).tz("Etc/GMT").format("DD.MM.YYYY");
  },
};
app.use(router).use(store).use(VueSweetalert2);
app.mount("#app");
